import {CardActions} from '@mui/material'
import {React, styled} from 'common'
import Card from '../Display/Card'
import MediaPlayer from '../Dance/Media/Card/MediaPlayer'
import {Toaster} from 'react-hot-toast'
import {Colors, Texts} from 'appearance'
import AddTaskIcon from '@mui/icons-material/AddTask'
import CancelIcon from '@mui/icons-material/Cancel'
import useMediaActions from 'logic/Media/useMediaActions.js'

const DanceRequestCard = ({media}) => {
    const {
        requestTitle,
        confirmText,
        confirmRequest,
        refuseRequest,
        isSong,
        buttonSX,
    } = useMediaActions(media)

    return (
        <RequestsCard>
            <RequestDescription>{requestTitle}</RequestDescription>
            <MediaPlayer isSong={isSong} url={media?.url} />
            <BottomContainer isSong={isSong}>
                <RequestStatus>{confirmText}</RequestStatus>
                <ActionsContainer>
                    <ConfirmButton sx={buttonSX} onClick={confirmRequest} />
                    <CancelButton sx={buttonSX} onClick={refuseRequest} />
                </ActionsContainer>
            </BottomContainer>
            <Toaster />
        </RequestsCard>
    )
}

export default DanceRequestCard

const RequestsCard = styled(Card)`
    display: flex;
    width: 240px;
    border-radius: 10px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    margin: 10px;
    justify-content: center;
`
const RequestDescription = styled(Texts.BoldText)`
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
`
const RequestStatus = styled(RequestDescription)`
    font-size: 16px;
    text-align: center;
    margin: 10px 0px;
`
const ActionsContainer = styled(CardActions)`
    justify-content: space-around;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex: 1;
`
const CancelButton = styled(CancelIcon)`
    color: red;
    cursor: pointer;
    &:hover {
        background-color: ${Colors.OPAC_RED};
        border-radius: 12px;
    }
`
const ConfirmButton = styled(AddTaskIcon)`
    color: ${Colors.TORQUISE};
    cursor: pointer;
    &:hover {
        background-color: ${Colors.OPAC_BLUE};
        border-radius: 12px;
    }
`
const BottomContainer = styled.div`
    ${({isSong}) => isSong && 'margin-top:110px'};
`
